import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { createApi } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";
import { EmployeeResponse, EmployeesView } from "./model/employee";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const employeeApi = createApi({
  reducerPath: "employeeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    }
  }),
  endpoints: (builder) => ({
    // result type = EmployeesView, arg type = string
    getEmployees: builder.query<EmployeesView, string>({
      query: (qs) => `/api/v2/employees?${qs}`,
      // server returns EmployeeResponse; map it to EmployeesView
      transformResponse: (response: EmployeeResponse): EmployeesView => ({
        data: response.attorneys,
        count: response.meta?.count ?? 0
      })
    })
  })
});

export const { useGetEmployeesQuery } = employeeApi;
